export default "__VITE_ASSET__t9ztJPGf__";